import React, { useCallback, useEffect, useState } from "react"
import { PaySetting, PaySettings } from "../../services/authinterface"
import { useFormik } from "formik"

import { request } from "../../services/request"
import * as Yup from "yup"
import { Form } from "react-bootstrap"

import { toast, ToastContainer } from "react-toastify"
import { useNavigate } from "react-router-dom"
import PrimaryButton from "../../components/subComponents/PrimaryButton"
// import SecondaryButton from "../../components/subComponents/SecondaryButton"
import ToggleSwitch from "../../components/common/ToggleSwitch"
import SecondaryButton from "../../components/subComponents/SecondaryButton"
import { useDispatch } from "react-redux"

import { changeloaderState } from "../../store/loaderSlice"
import { AppDispatch } from "../../store/store"

const PaymentSetting: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()

  // const param = useParams()
  const [paySetting, setPaySetting] = useState<PaySetting | null>(null)
  const [status, setStatus] = useState<boolean>(false)

  const fetchPaySettingDetails = useCallback(async () => {
    try {
      dispatch(changeloaderState(true))

      const response = await request<PaySettings>({
        url: `/adminPaySetting/getPaySettingDetails`,
        method: "GET",
      })

      if (response.success) {
        setPaySetting(response.data)
        setStatus(response.data?.status === "1" ? true : false)
      } else {
        toast.error("Failed to fetch paySetting: " + response.message)
      }
    } catch (error) {
    } finally {
      dispatch(changeloaderState(false))
    }
  }, [dispatch])

  useEffect(() => {
    fetchPaySettingDetails()
  }, [fetchPaySettingDetails])

  const validationSchema = Yup.object().shape({
    test_stripe_secret: Yup.string().trim().required("Please enter test stripe secret"),
    test_stripe_webhook_secret: Yup.string().trim().required("Please enter test webhook secret"),
    test_SOS_bill_amount: Yup.number()
      .typeError("Test SOS bill amount must be a number")
      .required("Please enter test SOS bill amount")
      .min(0, "Test SOS bill amount must be positive"),
    test_Sensor_bill_amount: Yup.number()
      .typeError("Test Sensor bill amount must be a number")
      .required("Please enter test sensor bill amount")
      .min(0, "Test Sensor bill amount must be positive"),
    stripe_secret: Yup.string().trim().required("Please enter stripe secret"),
    stripe_webhook_secret: Yup.string().trim().required("Please enter webhook secret"),
    SOS_bill_amount: Yup.number()
      .typeError("SOS bill amount must be a number")
      .required("Please enter SOS bill amount")
      .min(0, "SOS bill amount must be positive"),
    Sensor_bill_amount: Yup.number()
      .typeError("Sensor bill amount must be a number")
      .required("Please enter Sensor bill amount")
      .min(0, "Sensor bill amount must be positive"),
    test_custom_productId: Yup.string().trim().required("Please enter test custom product id"),
    custom_productId: Yup.string().trim().required("Please enter custom product id"),
  })

  const formik = useFormik({
    initialValues: {
      test_stripe_secret: paySetting?.test_stripe_secret || "",
      test_stripe_webhook_secret: paySetting?.test_stripe_webhook_secret || "",
      test_SOS_bill_amount: paySetting?.test_SOS_bill_amount || "",
      test_Sensor_bill_amount: paySetting?.test_Sensor_bill_amount || "",

      stripe_secret: paySetting?.stripe_secret || "",
      stripe_webhook_secret: paySetting?.stripe_webhook_secret || "",
      SOS_bill_amount: paySetting?.SOS_bill_amount || "",
      Sensor_bill_amount: paySetting?.Sensor_bill_amount || "",
      test_custom_productId: paySetting?.test_custom_productId || "",
      custom_productId: paySetting?.custom_productId || "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const response = await request<PaySettings>({
          url: `/adminpaySetting/updatePaySetting`,
          method: "POST",
          data: values,
        })
        if (response.success) {
          toast.success(response.message)
          setTimeout(() => {
            navigate(`/paymentSetting`)
          }, 1000)
        } else {
          toast.error(response.message)
        }
      } catch (error: any) {
        toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
      }
    },
  })

  const handleToggle = async () => {
    setStatus((prev) => !prev)
    try {
      const response = await request<PaySettings>({
        url: `/adminpaySetting/updateStatus`,
        method: "POST",
        data: { status: !status ? "1" : "0" },
      })
      if (response.success) {
        toast.success(response.message)
        setTimeout(() => {
          navigate(`/paymentSetting`)
        }, 1000)
      } else {
        toast.error(response.message)
      }
    } catch (error: any) {
      toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
    }
  }
  return (
    <section className='dashboard-section'>
      <ToastContainer position='top-right' autoClose={2000} theme='light' />
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-12'>
            <div className='dashboard-table-title-section title-line'>
              <h2>Payment Settings</h2>
              <ToggleSwitch
                isOn={status}
                handleToggle={handleToggle}
                onLabel='Live Mode'
                offLabel='Test Mode'
              />
            </div>
          </div>
          <div className='col-xl-8 col-lg-10 col-md-10 col-12 mt-4 w-100'>
            <form onSubmit={formik.handleSubmit} className='customer-edit-form'>
              {/* <ToggleSwitch
                  isOn={status}
                  handleToggle={handleToggle}
                  onLabel='Live Mode'
                  offLabel='Test Mode'
                /> */}
              <div className='row'>
                <div className='col-12 col-sm-6'>
                  <div className='form-group login-input-section'>
                    <label htmlFor='test_stripe_secret'>Test Stripe Test Secret</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='test_stripe_secret'
                      name='test_stripe_secret'
                      placeholder='Enter test stripe secret'
                      value={formik.values.test_stripe_secret}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        !!formik.errors.test_stripe_secret && formik.touched.test_stripe_secret
                      }
                    />

                    <span className='text-red-500 text-xs'>
                      {formik.touched.test_stripe_secret && formik.errors.test_stripe_secret}
                    </span>
                  </div>
                </div>

                <div className='col-12 col-sm-6'>
                  <div className='form-group login-input-section'>
                    <label htmlFor='stripe_secret'>Stripe Live Secret</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='stripe_secret'
                      name='stripe_secret'
                      placeholder='Enter test stripe secret'
                      value={formik.values.stripe_secret}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={!!formik.errors.stripe_secret && formik.touched.stripe_secret}
                    />

                    <span className='text-red-500 text-xs'>
                      {formik.touched.stripe_secret && formik.errors.stripe_secret}
                    </span>
                  </div>
                </div>

                <div className='col-12 col-sm-6'>
                  <div className='form-group login-input-section'>
                    <label htmlFor='test_stripe_webhook_secret'>Test Stripe Webhook Secret</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='test_stripe_webhook_secret'
                      name='test_stripe_webhook_secret'
                      placeholder='Enter test webhook key'
                      value={formik.values.test_stripe_webhook_secret}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        !!formik.errors.test_stripe_webhook_secret &&
                        formik.touched.test_stripe_webhook_secret
                      }
                    />

                    <span className='text-red-500 text-xs'>
                      {formik.touched.test_stripe_webhook_secret &&
                        formik.errors.test_stripe_webhook_secret}
                    </span>
                  </div>
                </div>
                <div className='col-12 col-sm-6'>
                  <div className='form-group login-input-section'>
                    <label htmlFor='stripe_webhook_secret'>Stripe Live Webhook Secret</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='stripe_webhook_secret'
                      name='stripe_webhook_secret'
                      placeholder='Enter webhook key'
                      value={formik.values.stripe_webhook_secret}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        !!formik.errors.stripe_webhook_secret &&
                        formik.touched.stripe_webhook_secret
                      }
                    />

                    <span className='text-red-500 text-xs'>
                      {formik.touched.stripe_webhook_secret && formik.errors.stripe_webhook_secret}
                    </span>
                  </div>
                </div>

                <div className='col-12 col-sm-6 col-lg-3'>
                  <div className='form-group login-input-section'>
                    <label htmlFor='test_SOS_bill_amount'>Test SOS Bill Amount</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='test_SOS_bill_amount'
                      name='test_SOS_bill_amount'
                      placeholder='Enter test SOS Bill Amount'
                      value={formik.values.test_SOS_bill_amount}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        !!formik.errors.test_SOS_bill_amount && formik.touched.test_SOS_bill_amount
                      }
                    />

                    <span className='text-red-500 text-xs'>
                      {formik.touched.test_SOS_bill_amount && formik.errors.test_SOS_bill_amount}
                    </span>
                  </div>
                </div>
                <div className='col-12 col-sm-6 col-lg-3'>
                  <div className='form-group login-input-section'>
                    <label htmlFor='test_Sensor_bill_amount'>Test Sensor Bill Amount</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='test_Sensor_bill_amount'
                      name='test_Sensor_bill_amount'
                      placeholder='Enter test SOS Bill Amount'
                      value={formik.values.test_Sensor_bill_amount}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        !!formik.errors.test_Sensor_bill_amount &&
                        formik.touched.test_Sensor_bill_amount
                      }
                    />

                    <span className='text-red-500 text-xs'>
                      {formik.touched.test_Sensor_bill_amount &&
                        formik.errors.test_Sensor_bill_amount}
                    </span>
                  </div>
                </div>
                <div className='col-12 col-sm-6 col-lg-3'>
                  <div className='form-group login-input-section'>
                    <label htmlFor='SOS_bill_amount'>Live SOS Bill Amount</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='SOS_bill_amount'
                      name='SOS_bill_amount'
                      placeholder='Enter SOS Bill Amount'
                      value={formik.values.SOS_bill_amount}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={!!formik.errors.SOS_bill_amount && formik.touched.SOS_bill_amount}
                    />

                    <span className='text-red-500 text-xs'>
                      {formik.touched.SOS_bill_amount && formik.errors.SOS_bill_amount}
                    </span>
                  </div>
                </div>
                <div className='col-12 col-sm-6 col-lg-3'>
                  <div className='form-group login-input-section'>
                    <label htmlFor='Sensor_bill_amount'>Live Sensor Bill Amount</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='Sensor_bill_amount'
                      name='Sensor_bill_amount'
                      placeholder='Enter SOS Bill Amount'
                      value={formik.values.Sensor_bill_amount}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        !!formik.errors.Sensor_bill_amount && formik.touched.Sensor_bill_amount
                      }
                    />

                    <span className='text-red-500 text-xs'>
                      {formik.touched.Sensor_bill_amount && formik.errors.Sensor_bill_amount}
                    </span>
                  </div>
                </div>

                <div className='col-12 col-sm-6'>
                  <div className='form-group login-input-section'>
                    <label htmlFor='stripe_secret'>Test Custom Product Id</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='test_custom_productId'
                      name='test_custom_productId'
                      placeholder='Enter Test Custom Product Id'
                      value={formik.values.test_custom_productId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        !!formik.errors.test_custom_productId &&
                        formik.touched.test_custom_productId
                      }
                    />

                    <span className='text-red-500 text-xs'>
                      {formik.touched.test_custom_productId && formik.errors.test_custom_productId}
                    </span>
                  </div>
                </div>

                <div className='col-12 col-sm-6'>
                  <div className='form-group login-input-section'>
                    <label htmlFor='stripe_webhook_secret'>Live Custom Product Id</label>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='custom_productId'
                      name='custom_productId'
                      placeholder='Enter Custom Product Id'
                      value={formik.values.custom_productId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        !!formik.errors.custom_productId && formik.touched.custom_productId
                      }
                    />

                    <span className='text-red-500 text-xs'>
                      {formik.touched.custom_productId && formik.errors.custom_productId}
                    </span>
                  </div>
                </div>
                <div className='col-12'>
                  <div className='d-flex gap-3 justify-content-center'>
                    <div className='d-flex gap-3'>
                      <PrimaryButton
                        type='submit'
                        label='Submit'
                        className='editFormButton w-100'
                      />
                      <SecondaryButton
                        type='button'
                        onClick={() => {
                          formik.resetForm()
                          fetchPaySettingDetails()
                        }}
                        label='Reset'
                        className='editFormButton w-100'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PaymentSetting
